import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import client from '../../LikePlusClient'
import clientCustom from '../../LikePlusClientCustom'
import { connect } from 'react-redux'
import ModalRegulation from '../ModalRegulation'
import ModalRegulationCustom from '../ModalRegulationCustom'
import PulseLoader from 'react-spinners/PulseLoader'
import yn from 'yn'
import { formatNumber } from '../../Helpers'

class RechargeAside extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modalVisible: false,
      showRegulation: false,
      customPoints: null,
      customTaxes: []
    }
    this.finishRescue = this.finishRescue.bind(this)
    this.handleRegulation = this.handleRegulation.bind(this)
  }

  componentDidUpdate (prevProps) {
    if (yn(process.env.REACT_APP_HAS_LIKE_PLUS_CUSTOM)) {
      if (prevProps.rechargePoints !== this.props.rechargePoints) {
        this.handleCustomTaxes([])
        this.handleCustomPoints(null)
        this.handleCardTaxesCustom()
      }
    }
  }

  handleRegulation = () => {
    this.setState({ showRegulation: !this.state.showRegulation })
  }

  handleCustomPoints = (customPoints) => {
    this.setState({ customPoints })
  }

  handleCustomTaxes = (customTaxes) => {
    this.setState({ customTaxes })
  }

  returnPoints = (pointsValue) => {
    return formatNumber(pointsValue.toString().replace('.', '')) + ' ' + this.props.pointsName
  }

  async handleCardTaxesCustom () {
    const points = this.props.rechargePoints
    if (points) {
      let result = await this.props.handleCardTaxesCustom(points, this.props.accessToken)
      this.handleCustomPoints(result)
      this.handleCustomTaxes(result.taxes)
    }
  }

  finishRescue () {
    if (this.props.rechargePoints > 0 && this.props.disabledConfirmButton === false) {
      if ((this.props.rechargePoints <= this.props.balance.pointsValue)) {
        this.props.handleDisabledConfirmButton(true)
        this.props.handleLoadingConfirmButton(true)

        let payload = null
        let clientRequest = null

        if (yn(process.env.REACT_APP_HAS_LIKE_PLUS_CUSTOM)) {
          payload = this.createPayloadCustom()
          clientRequest = clientCustom
        } else {
          payload = this.createPayload()
          clientRequest = client
        }

        clientRequest.redemptionCard(payload, this.props.accessToken)
          .then((response) => {
            console.log('response', response)
            this.handleAlert(true, false, 'Sucesso !!!', 'A solicitação de recarga foi solicitada com sucesso')
            this.props.handleSuccess(true)
            this.props.handleTransactionId(response.order.liveOrderId)
          }).catch((error) => {
            console.log('error', error)
            // TODO: remover isso, apenas para testar
            const errorMessage = error.response.data ? error.response.data.errors : 'Houve algum erro ao pedir o seu cartão. Por favor tente novamente.'
            this.handleAlert(true, true, 'Ocorreu um erro ao solicitar o seu cartão!', errorMessage)
            this.props.handleSuccess(false)
            this.props.handleDisabledConfirmButton(false)
            this.props.handleLoadingConfirmButton(false)
          })
      } else {
        this.handleAlert(true, true, 'Oops !!!', 'O valor a ser creditado é maior do que o saldo disponivel, por favor revise a quantidade ou consiga mais saldo')
      }
    }
  }

  createPayload () {
    let cpf = this.props.participant.cpf.value
    let name = this.props.participant.name.value
    let obj = {
      totalMiles: parseFloat(this.props.rechargeCredits),
      totalPoints: parseFloat(this.props.rechargePoints),
      transferKey: 'cpf',
      loyaltyNumber: cpf,
      cpf: cpf,
      participantName: name,
      offline: false,
      orderItems: [],
      orderTypeId: 3
    }

    obj.orderItems.push(this.getPoints())

    return obj
  }

  createPayloadCustom () {
    let cpf = this.props.participant.cpf.value
    let name = this.props.participant.name.value
    let obj = {
      totalMiles: parseFloat(this.state.customPoints.money),
      totalPoints: parseFloat(this.state.customPoints.points),
      transferKey: 'cpf',
      loyaltyNumber: cpf,
      cpf: cpf,
      participantName: name,
      offline: false,
      orderItems: [],
      orderTypeId: 3
    }

    obj.orderItems.push({
      'quantity': 1,
      'miles': this.state.customPoints.money,
      'totalPoints': this.state.customPoints.money,
      'packageName': 'Crédito Cartão Pré-Pago Like+'
    })

    this.state.customTaxes.map((x) => {
      obj.orderItems.push({
        'quantity': 1,
        'miles': x.totalCalculedTax,
        'totalPoints': x.totalCalculedTax,
        'packageName': x.description
      })
    })

    return obj
  }

  getPoints () {
    let points = parseFloat(this.props.rechargePoints)
    let miles = parseFloat(this.props.rechargeCredits)
    let obj = {
      quantity: 1,
      points: points,
      miles: miles,
      totalPoints: points,
      packageName: `${points} Pontos Like+`
    }

    return obj
  }

  handleAlert (show, isError, title, message) {
    let alert = {
      show,
      isError,
      title,
      message
    }
    this.props.handleAlert(alert)
  }

  getDate () {
    return moment().format('LLL')
  }

  render () {
    return (
      <Fragment>
        <div className='border-color-ui-3 bg-white border px-3 py-4'>
          {this.props.success
            ? (<h3>Sobre sua solicitação</h3>)
            : (<h3>Resumo da solicitação</h3>)
          }
        </div>
        <div className='border-color-ui-3 bg-ui-4 p-0 col-12 border-right border-left'>
          <div className='border-bottom border-color-ui-3 px-3 py-2'>
            <p className='mb-2'><strong>Recarga Cartão Pré-Pago Like+</strong></p>
            {this.props.success
              ? (
                <Fragment>
                  <p>Realizada em: <strong>{this.getDate()}</strong></p>
                  <p>{`Total de ${this.props.pointsName} utilizados:`} <strong>{this.returnPoints(this.props.rechargePoints)}</strong></p>
                  <p>Valor em reais creditado: <strong>{formatNumber(this.props.rechargeCredits, true)}</strong></p>
                </Fragment>
              ) : (
                <Fragment>
                  <p>Recarga: <strong>{this.returnPoints(this.props.rechargePoints)}</strong></p>
                  {yn(process.env.REACT_APP_HAS_LIKE_PLUS_CUSTOM) &&
                    (
                      this.state.customTaxes.map((x) => {
                        return (
                          <p>{x.description}: <strong>{formatNumber(x.totalCalculedTax, true)}</strong></p>
                        )
                      })
                    )
                  }
                  <p>Valor em reais a ser creditado: <strong>{formatNumber(this.props.rechargeCredits, true)}</strong></p>
                </Fragment>
              )}
          </div>
          <div className='px-3 py-2'>
            <p>Solicitante: <strong>{this.props.participant.name.value}</strong></p>
            <p>CPF: <strong>{this.props.participant.cpf.value}</strong></p>
          </div>
        </div>
        <div className='border-color-ui-3 p-0 col-12 bg-white border'>
          {!this.props.success && (
            <div className='d-flex justify-content-between px-3 py-2'>
              <p>{`Total de ${this.props.pointsName} utilizados:`}</p>
              <p><strong>{this.returnPoints(this.props.rechargePoints)}</strong></p>
            </div>
          )}
          <div className='px-3 py-2'>
            {this.props.success
              ? (
                <Fragment>
                  <button className='btn btn-featured btn-icon txt-button txt-font-body' onClick={() => window.print()} >
                    <i className='icon icon_copy' aria-hidden='true' /> IMPRIMIR PEDIDO
                  </button>
                </Fragment>
              ) : (
                <Fragment>
                  <p className='mb-2'>Ao finalizar declaro que li e aceito os <a href='javascript:void(0)' onClick={this.handleRegulation} className='cursor txt-underline color-brand-2-like'>termos do regulamento.</a></p>
                  <a className='btn btn-featured btn-icon txt-button txt-font-body'
                    disabled={this.props.disabledConfirmButton}
                    role='button'
                    onClick={this.finishRescue}
                  >
                    {this.props.loadingConfirmButton
                      ? (
                        <div className='col-12' style={{ textAlign: 'center' }}>
                          <PulseLoader
                            color={'#626365'}
                            loading
                            size={12}
                            margin={4}
                          />
                        </div>
                      ) : (
                        <Fragment>
                          <i className='icon icon_gift' aria-hidden='true' /> FINALIZAR RESGATE
                        </Fragment>
                      )
                    }
                  </a>
                  {yn(process.env.REACT_APP_HAS_LIKE_PLUS_CUSTOM_MESSAGE)
                    ? (
                      <ModalRegulationCustom isOpen={this.state.showRegulation} handleClose={this.handleRegulation} />
                    ) : (
                      <ModalRegulation isOpen={this.state.showRegulation} handleClose={this.handleRegulation} />
                    )
                  }
                </Fragment>
              )}
          </div>
        </div>
      </Fragment>
    )
  }
}

RechargeAside.propTypes = {
  pointsName: PropTypes.string,
  success: PropTypes.bool,
  rechargePoints: PropTypes.number,
  rechargeCredits: PropTypes.number,
  participant: PropTypes.object,
  handleSuccess: PropTypes.func,
  accessToken: PropTypes.string,
  balance: PropTypes.object,
  handleAlert: PropTypes.func,
  handleCardTaxesCustom: PropTypes.func,
  handleTransactionId: PropTypes.func,
  disabledConfirmButton: PropTypes.bool,
  handleDisabledConfirmButton: PropTypes.func,
  loadingConfirmButton: PropTypes.bool,
  handleLoadingConfirmButton: PropTypes.func
}

const mapStateToProps = ({ catalog: { currencyConfiguration } }) => ({
  pointsName: currencyConfiguration.pointsName
})

export default connect(
  mapStateToProps,
  null
)(RechargeAside)



// WEBPACK FOOTER //
// ./src/features/LikePlusCustom/Tabs/Recharge/RechargeAside.js